module.exports = __webpack_public_path__ + "static/media/LetzteProspektseite_A4.0c61a5cf.jpg";